/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchePlanLocalisationDto } from './FcbRecherchePlanLocalisationDto';
import {
    FcbRecherchePlanLocalisationDtoFromJSON,
    FcbRecherchePlanLocalisationDtoFromJSONTyped,
    FcbRecherchePlanLocalisationDtoToJSON,
} from './FcbRecherchePlanLocalisationDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchePlanLocalisationDtoPaginatedResults
 */
export interface FcbRecherchePlanLocalisationDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchePlanLocalisationDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchePlanLocalisationDto>}
     * @memberof FcbRecherchePlanLocalisationDtoPaginatedResults
     */
    results?: Array<FcbRecherchePlanLocalisationDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchePlanLocalisationDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchePlanLocalisationDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchePlanLocalisationDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchePlanLocalisationDtoPaginatedResultsFromJSON(json: any): FcbRecherchePlanLocalisationDtoPaginatedResults {
    return FcbRecherchePlanLocalisationDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchePlanLocalisationDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchePlanLocalisationDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchePlanLocalisationDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchePlanLocalisationDtoPaginatedResultsToJSON(value?: FcbRecherchePlanLocalisationDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchePlanLocalisationDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

